export default __webpack_public_path__ + "static/media/security.676c2961.svg";